import Vue from 'vue'
import App from './App.vue'
import router from './router.js'
import store from './store/store'
import '../public/common.css'

import { Lazyload } from 'vant';

Vue.use(Lazyload);
Vue.use(Lazyload, {
  lazyComponent: true,
  attempt: 1
});

Vue.config.productionTip = false
document.title = 'Globalway'

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')